import { DUPLEXER_CHANNELS, DUPLEXER_EVENTS } from '../../../universal/constants/duplexer';
import { updateCategoryCounters, updatePostCounters } from '../../actions/category-socket';

export default {
  [DUPLEXER_CHANNELS.FORUM]: {
    [DUPLEXER_EVENTS.UPDATE_POST_COUNTERS]: updatePostCounters,
    [DUPLEXER_EVENTS.UPDATE_CATEGORY_COUNTERS]: updateCategoryCounters,
  },
};
